import WooCommerceApi from '@woocommerce/woocommerce-rest-api'

const WooCommerce = new WooCommerceApi({
    url: 'https://vinosdev.com',
    consumerKey: 'ck_9af9353c59e9b12a9766df5c4801b837b0edf9d7',
    consumerSecret: 'cs_57d594bd5261a0e80398535cdaf6d80e2752dd51',
    version: 'wc/v3'
})

export default WooCommerce